export default __webpack_public_path__ + "static/media/twitter.cbfb1f67.png";